import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { AppAuthProvider } from "./context";

const cognitoAuthConfig = {
    authority:
        "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_iwIWRB0Qr",
    client_id: "2rt245npheca1rkm9umdqd79e",
    // Fixed, single registered callback URL - must exactly match an allowed
    // callback URL in the Cognito App Client. AuthContext's login() records
    // the page the user was actually on (in sessionStorage) and restores it
    // after the redirect back, so this no longer needs to vary per-page.
    redirect_uri: window.location.origin,
    response_type: "code",
    scope: "email openid phone",
    // Cognito issues a refresh_token with the authorization_code exchange, so
    // oidc-client-ts renews via a direct refresh_token POST rather than the
    // prompt=none hidden-iframe flow - no silent_redirect_uri/CSP issue.
    automaticSilentRenew: true,
    loadUserInfo: false,
    monitorSession: false,
    checkSessionInterval: 0,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <AuthProvider {...cognitoAuthConfig}>
            <AppAuthProvider config={cognitoAuthConfig}>
                <App />
            </AppAuthProvider>
        </AuthProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
